import axios from "axios"
const state = {
  STATUS: null,
  API_ROUTE: "/lookup/lookupmaster",
  lookup: []
}

const getters = {
  lookup: (state) => state.lookup
}

const mutations = {
  setLookup(state, list, masterName) {
    state.lookup[masterName] = list
  }
}

const actions = {
  async listLookupsByMasterName({ commit }, masterName) {
    try {
      const url = `${process.env.VUE_APP_URL}${state.API_ROUTE}/${masterName}`

      const config = {
        headers: {
          "Content-Type": "application/json"
        }
      }
      const response = await window.axios.get(url, config)
      commit("setDoctors", response.data, masterName)

      return response.data
    } catch (error) {
      state.STATUS = "An error occurred: " + error
      throw error
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
